/**
 * Alert messages for app
 *
 * @author Mamontov Andrey, 08/2018
 */

export class AppAlerts {

  /**
   * System
   */

  /**
   * Common
   */
  public static readonly SAVE_OBJECT_TITLE = 'Сохраняем?';
  public static readonly DELETE_OBJECT_TITLE = 'Удаляем?';
  public static readonly DELETE_OBJECT_TEXT = 'Выбранный объект будет удален навсегда';
  public static readonly INCORRECT_EMAIL_ERROR = 'Некорректный адрес электронной почты';
  //
  // public static readonly ACTION_APPROVE_TITLE = 'Сохраняем?';
  //
  public static readonly OBJECT_IS_EMPTY = 'Вы не заполнили ни одного поля!';

  public static readonly OBJECT_USER_CHEKS_ERROR = 'Ошибка проверки данных!';

  public static readonly DICTIONARY_DUPLICATE_ERROR = 'Данный элемент уже есть в справочнике!';

  public static readonly ERROR_REQUIRED_FIELDS = 'Не заполнены обязательные поля';
  public static readonly ERROR_NUMBER_FIELD = 'Не корректно заполнено поле';

  /**
   * Reception
   */
  public static readonly RECEPTION_COMPLAINT_ERROR = 'При отправке ваше обращения возникли ошибки. Попробуйте еще раз.';
  public static readonly RECEPTION_COMPLAINT_TITLE = 'Внимание!';
  public static readonly RECEPTION_COMPLAINT_TEXT = 'Если вы прикрепляли файлы к обращению, убедитесь, что они загрузились.';
  public static readonly RECEPTION_REQUIRED_FIELDS_ERROR = 'Не заполнены обязательные поля. Обратите внимание на поля, где имеются выбираемые значения.';
  public static readonly RECEPTION_COMPLAINT_VERY_OFTEN = 'Вы превышаете допустимый интервал задержки при отправке обращения';

  /**
   * Incomes
   */
  public static readonly MEMBER_IS_EMPTY = 'Вы не выбрали работника для которого заполняете форму!';
  public static readonly FINANCE_LANDS_ERROR = 'Площадь помещения указана некорректно!';
  public static readonly FINANCE_OBJECT_DELETE_TEXT = 'Объект будет удален со всеми связанными данными!';

}
